import { Link } from "react-router-dom";
import { movieItems, newsItems, varietyItems } from "@/mocks/content";

export default function SiteIntro() {
  const stats = [
    { value: `${newsItems.length + movieItems.length + varietyItems.length}+`, label: "在库内容" },
    { value: "3", label: "核心频道" },
    { value: "每日", label: "持续更新" },
    { value: "100%", label: "虚构演示数据" },
  ];

  return (
    <section className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-8">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.15fr_1fr] lg:items-center lg:gap-10">
        <div>
          <p className="flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.24em] text-primary-600">
            <span className="h-3 w-1 rounded-full bg-primary-500" />
            关于红桃网
          </p>
          <h2 className="mt-2 font-heading text-xl font-black text-foreground-950 md:text-[26px]">
            一个认真聊娱乐的地方
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
            红桃网关注电影、电视剧与综艺，也关注每一个看完之后还想说点什么的人。我们把资讯整理清楚，把推荐讲明白，把讨论的地方留给你。
          </p>
          <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-500">
            本站为演示项目，内容与数据均为虚构示例，互动功能停留在前端演示层面，不涉及真实账号与后台存储。
          </p>
          <div className="mt-5 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="cursor-pointer whitespace-nowrap rounded-full bg-foreground-950 px-5 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              了解红桃网
            </Link>
            <Link
              to="/community"
              className="cursor-pointer whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-5 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              去互动专区看看
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          {stats.map((stat) => (
            <div key={stat.label} className="rounded-lg border border-background-200 bg-background-50 px-4 py-4">
              <p className="font-label text-xl font-extrabold text-foreground-950 md:text-2xl">{stat.value}</p>
              <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}